import { MDBIcon } from "mdb-react-ui-kit";
import { useContext } from 'react';
import useResumeHobbiesHandlers from "../../../context/resume/hooks/resume-hobbies-handlers";
import { TranslationContext } from "../../../context/translations/translations-context";

export default function AddHobby() {

    const { translations } = useContext( TranslationContext );
    const { handleAdd } = useResumeHobbiesHandlers();

    return (
        <button className="btn_primary" onClick={ handleAdd }>
            <MDBIcon fas
                     icon="plus-circle"
                     color='light'
                     size='sm'
                     title={ translations.hobbiesSection.addHobbyLabel }
            />
            <span className='ms-1'>{ translations.hobbiesSection.addHobbyLabel }</span>
        </button>
    )
}
